import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// import Select from '../../Common/Select';
// import TextField from '../../Common/TextField';
import ExtraFields from '../../Common/ExtraFields';

// import { Scope } from 'informed';
// import { Cell } from 'react-md';

// import Button from '@material-ui/core/Button';
// import Divider from '@material-ui/core/Divider';

class ExtraBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // selectedValue: '',
      expanded: true,
    };
  }

  static componentDidMount() {
    const { expanded } = this.props;
    this.setState({
      expanded,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { expanded } = nextProps;
    let newState = null;
    if (expanded !== prevState.expanded) {
      newState = newState ? Object.assign(newState, { expanded }) : { expanded };
    }
    return newState;
  }

  render() {
    const { formApi, i18n, ...props } = this.props;
    const { data, onSave, strings, classes, setExpanded, values, readOnly, tooltip } = props;
    const { expanded } = this.state;
    const { extra } = data;

    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
      this.setState({
        expanded: false,
      });
      onSave(formApi.getState().values);
    };

    const toggleExpanded = () => {
      setExpanded('extra', !expanded);
    };
    // const summary = items => {
    //   if (items) {
    //     const renderedItems = [];
    //     map(items, (value, key) => {
    //       console.log('summary', value, key);
    //       renderedItems.push(
    //         <Fragment key={`item-${key}`}>
    //           <span className="extra-block-item-key">{key}</span>
    //           <span key={key} className="extra-block-item-value">
    //             {value}
    //           </span>
    //         </Fragment>
    //       );
    //     });
    //     return renderedItems;
    //   }
    //   return undefined;
    // };
    if (Array.isArray(extra) && extra.length > 0) {
      return (
        <ExpansionPanel
          className={`expansion-panel ${expanded ? 'expanded' : ''}`}
          expanded={expanded}
          onChange={toggleExpanded}
        >
          <ExpansionPanelSummary
            className="expansion-panel-summary"
            expandIcon={<ExpandMoreIcon className="expansion-more-icon" />}
          >
            <span className="extra-block-title">{strings['block.extra.title']}</span>
            {/* {summary(values.extra)} */}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            {/* tips: to create array in scope => scope={`extra[${index}]`} */}
            {/* <Scope scope="extra">
              {extra.map(model => (
                <div key={model.code} className={Cell.getClassName({ size: 6 })}>
                  {renderExtraField(model)}
                </div>
              ))} 
            </Scope> */}
            <ExtraFields
              formApi={formApi}
              data={extra}
              onSave={onSave}
              strings={strings}
              classes={classes}
              values={values.extra}
              readOnly={readOnly}
              i18n={i18n}
              tooltip={tooltip}
            />
          </ExpansionPanelDetails>
          {/* <Divider />
          <ExpansionPanelActions>
            <Button size="small" color="primary" onClick={handleSave}>
              {strings['block.btn.save.label']}
            </Button>
          </ExpansionPanelActions> */}
        </ExpansionPanel>
      );
    }
    return '';
  }
}

ExtraBlock.propTypes = {
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  formState: PropTypes.any.isRequired, // eslint-disable-line
  data: PropTypes.any.isRequired, // eslint-disable-line
  onSave: PropTypes.func.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  classes: PropTypes.any.isRequired, // eslint-disable-line
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  i18n: PropTypes.shape({
    lang: PropTypes.string,
  }).isRequired,
  tooltip: PropTypes.string,
};

ExtraBlock.defaultProps = {
  readOnly: false,
};

export default ExtraBlock;
